























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { isValidHexColor, luma, RGBToHSLObject } from '@/core/color/color.service';
import SmartParagraph from '@/core/ui-components/SmartParagraph.vue';

@Component({
    components: { SmartParagraph }
})
export default class CallToAction extends Vue {
    @Prop({ type: String, required: false })
    private text!: string;

    @Prop({ type: [String, Object], required: false })
    private href!: RawLocation;

    @Prop({ type: String, required: false, default: '' })
    private icon!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private iconIsAfter!: boolean;

    @Prop({ type: String, required: false })
    private target!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private autofocus!: boolean;

    @Prop({ type: String, required: false })
    private hexColor!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private dropdown!: boolean;

    @Prop({ type: String, default: 'button' })
    private type!: string;

    @Prop({ type: Number, default: -1 })
    private maxCharacters!: number;

    @Prop({
        type: Function,
        default: undefined
    })
    private onClickEvent!: () => {};

    private dropdownActive: boolean = false;

    public toggleDropdown() {
        this.dropdownActive = !this.dropdownActive;
    }

    public openDropdown() {
        this.dropdownActive = true;
    }

    public closeDropdown() {
        this.dropdownActive = false;
    }

    get hasIconBefore(): boolean {
        return this.icon !== '' && !this.iconIsAfter;
    }

    get hasIconAfter(): boolean {
        return this.icon !== '' && this.iconIsAfter;
    }

    private handleClick() {
        if (this.onClickEvent) {
            this.onClickEvent();
        }
        this.$emit('click');

        if (this.dropdown && !this.dropdownActive) {
            this.openDropdown();
        }
    }

    private get customBackgroundColor(): object {
        if (!this.hexColor) return {};
        if (!isValidHexColor(this.hexColor)) return {};

        return {
            backgroundColor: this.hexColor
        };
    }

    private mounted() {
        this.setForegroundAndHoverColor();
    }

    private setForegroundAndHoverColor() {
        const elementStyle = (this.$el as HTMLElement).style;
        const rawBackgroundColor = getComputedStyle(this.$el).backgroundColor;
        const [r, g, b] = rawBackgroundColor.replace(/[^\d,]/g, '').split(',');
        const { h, s, l } = RGBToHSLObject(r, g, b);
        const isDarkBackground = luma(r, g, b) <= 0.5;

        // Hover and active - adjust luminosity
        const hoverL = l * 0.85;
        elementStyle.setProperty('--hover-active-color', `hsl(${h}, ${s}%, ${hoverL}%)`);

        // Foreground
        elementStyle.color = isDarkBackground ? 'white' : 'black';
    }
}
